export default __webpack_public_path__ + "static/media/doctor.7b6060e7.png";